export default __webpack_public_path__ + "static/media/arrow-top-black.7c28818e.svg";